let tables = {

};
let enterFlag = true;
tables.init = function(vm) {
    let arr = vm.$store.state.table.tableMove;
    let arrCol = vm.$store.state.table.tableCol;
    let dwTable = document.getElementsByClassName('dw-table')[0];
    let tag = dwTable.getElementsByTagName('TH');
    for (let i = 0; i < tag.length; i++) {
        let item = tag[i];
        item.onmouseenter = function (event) {
            if(enterFlag) {
                if(event.target.tagName == 'TH') {
                    let name = event.path[6].classList[1];
                    tables.move(arrCol[name], name, event.target.cellIndex);
                } else if (event.target.tagName == 'DIV') {
                    let name = event.path[7].classList[1];
                    tables.move(arrCol[name], name, event.target.parentNode.cellIndex);
                } else if (event.target.tagName == 'SPAN') {
                    let name = event.path[8].classList[1];
                    tables.move(arrCol[name], name, event.target.parentNode.parentNode.cellIndex);
                }
            }
            // console.log(event.target.parentElement.parentElement.parentElement);
        }
    }
}
tables.move = function(columns, name){
    // that传入columns数据，name为table的classname
    let tabSize = tabSize || {};
    let self,
    num,
    table = document.getElementsByClassName(name)[0].children[0].children[0],
    header = table.children[0].children[1].rows[0],
    tableX = header.clientWidth,
    length = header.cells.length,
    para = document.createElement("p"),
    col = document.getElementsByClassName(name)[0].children[0].children[0].children[0].children[0],
    col2 = document.getElementsByClassName(name)[0].children[0].children[1].children[0].children[0];
    table.appendChild(para);
    table.children[1].style.width = '1px';
    table.children[1].style.height = '100%';
    table.children[1].style.top = '0px';
    table.children[1].style.left = '0px';
    table.children[1].style.position = 'absolute';
    table.children[1].style.background = '#e9eaec';
    table.children[1].style.display = 'none';

    let flag = 0;
    for (let i = 0; i < length; i++) {
        header.cells[i].onmousedown = function () {
            enterFlag = false;
            self = this;
            num = i;
            if (event.offsetX > self.offsetWidth - 10) {
                self.mouseDown = true;
                self.oldX = event.x;
                self.oldWidth = self.offsetWidth;
            }
            // 阻止默认事件，取消文字选中
            event.preventDefault();
        };
        let cell = header.cells[i];
        cell.onmousemove = function () {
            // 判断是否是最后一列，最后一列不可移动
            let isLast = Boolean(i == (columns.length-1));
            if ((event.offsetX > cell.offsetWidth - 10)&&!isLast) {
                cell.style.cursor = 'col-resize';
            } else {
                cell.style.cursor = 'default';
            }
            if (self == undefined) {
                self = cell;
            }
            if (self.mouseDown != null && self.mouseDown == true && !isLast) {
                self.style.cursor = 'default';
                self.style.cursor = 'col-resize';
            }
        };
        // 监听document的mousemove，当鼠标离开表头时也可拖动
        document.onmousemove = function () {
            if (self == undefined) {
                self = cell;
            }
            // 判断是否是最后一列，最后一列不可移动
            let isLast = Boolean(num == (columns.length-1));
            if (self.mouseDown != null && self.mouseDown == true && !isLast) {
                self.style.cursor = 'default';
                flag++
                let left = 0, scroll=0;
                // 判断滚动条滚动位置
                scroll = table.scrollWidth - table.offsetWidth;
                for (let i = 0; i < num+1; i++) {
                    left += parseInt(col.children[i].getAttribute('width'));
                }

                table.children[1].style.display = 'block';
                table.children[1].style.left = self.offsetWidth + self.offsetLeft - table.scrollLeft + (event.x - self.oldX) + 'px';
                self.style.cursor = 'col-resize';
            }
        };
        document.onmouseup = function () {
            enterFlag = true;
            // if (self == undefined) {
            //     self = that;
            // }
            if(flag>2){
                if (self.oldWidth + (event.x - self.oldX) > 0) {
                    self.width = self.oldWidth + (event.x - self.oldX);
                }
                if(self.width>=50&&num!=(columns.length-1)){
                    columns[num].width = parseInt(self.width);
                    if (columns[num].minWidth) {
                        columns[num].minWidth = parseInt(self.width);
                    }
                }
                // if(self.width>=50&&num!=(columns.length-1)){
                //     console.log(parseInt(self.width))
                //     col.children[num].setAttribute('width', parseInt(self.width));
                //     col2.children[num].setAttribute('width', parseInt(self.width));
                // }
                flag = 0;
            }
            self.mouseDown = false;
            self.style.cursor = 'default';
            tableX = header.clientWidth;
            table.children[1].style.display = 'none';
        };
    }
}


export default tables;


// WEBPACK FOOTER //
// ./src/views/main-components/table/tableMove.js